























































/* eslint-disable class-methods-use-this */

import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class SlcPagination extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  items: any[];

  @Prop({
    type: Object,
    default: () => ({})
  })
  menuButtonTheme: any;

  // NB: locale formated date
  @Prop()
  dateFrom: string;

  @Prop()
  startDate: string;

  @Prop()
  allowedDateRange: any;

  dateRangeFrom = "";

  @Watch("dateRangeFrom")
  onDateRangeFromChanged() {
    this.$emit("selectStartDate", { startDate: this.dateRangeFrom });
  }

  get navigationButtonClass() {
    return ({ icon }): string => {
      if (icon && icon === "navigate_before") {
        return "is-previous";
      }
      if (icon && icon === "navigate_next") {
        return "is-next";
      }
      return "";
    };
  }

  get navigationHiddenClass() {
    return ({ disabled }): string => {
      if (disabled) {
        return "is-hidden";
      }
      return "";
    };
  }

  mounted() {
    this.dateRangeFrom = this.startDate;
  }
}
